import React from "react";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import { NavLink, useLocation } from "react-router-dom"; // Import useLocation
import userIcon from "../../utils/icons/reshot-icon-user-QLCUYJBKM3 1.svg"; // Import the custom user icon
import psga from "../../utils/RxConnexion.png";
const Navbar = ({ auth, logoutUser, choosePlan = false }) => {
  const location = useLocation(); // Get the current route dynamically

  const onLogoutClick = (e) => {
    e.preventDefault();
    logoutUser();
  };

  const { user } = auth;

  // Extract initials from first_name and last_name
  const initials = `${(user.first_name || "").charAt(0).toUpperCase() || ""}${
    (user.last_name || "").charAt(0).toUpperCase() || ""
  }`;

  const generateColorFromInitials = (initials) => {
    let hash = 0;
    for (let i = 0; i < initials.length; i++) {
      hash = initials.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
  };
  const randomColor = generateColorFromInitials(initials);

  return (
    <div className="container-fluid p-0 navbar-container">
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          {!choosePlan &&
          location.pathname !== "/landing" && ( // Use location.pathname instead of window.location.pathname
              <NavLink activeClassName="is-active" to="/landing">
                <button
                  className="btn mt-2 mb-1 back-to-main-menu"
                  style={{ marginRight: "10px" }}
                >
                  <strong>
                    <img
                      src="/svg/arrow-left.svg"
                      alt="Back"
                      width="14"
                      height="14"
                    />
                    &nbsp;<span>Go to Main Menu</span>
                  </strong>
                </button>
              </NavLink>
            )}
          {choosePlan && (
            <NavLink activeClassName="is-active" to="/">
              <img style={{ width: "160px" }} src={psga} alt="Logo" />
            </NavLink>
          )}
          <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown active">
              <a
                className="nav-link dropdown-toggle d-flex align-items-center"
                href="#"
                id="lookups"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {/* Custom User Icon */}
                <img
                  src={userIcon}
                  alt="User Icon"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginRight: "15px",
                  }}
                />
                {/* Pipe */}
                <span
                  style={{
                    fontSize: "22px",
                    color: "#e2e2e2",
                    marginRight: "15px",
                  }}
                >
                  |
                </span>
                {/* Circle with initials */}
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    backgroundColor: randomColor,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "12px",
                  }}
                >
                  {initials}
                </div>
              </a>
              <ul
                style={{ left: "-150px" }}
                className="dropdown-menu"
                aria-labelledby="lookups"
              >
                {!auth.user.superadmin && (
                  <li>
                    <NavLink
                      activeClassName="is-active"
                      to={auth.user.superadmin ? "/config" : "/profile"}
                      className="list-group-item"
                    >
                      Settings
                    </NavLink>
                  </li>
                )}
                {!auth.user.superadmin && (
                  <>
                    <li>
                      <NavLink
                        activeClassName="is-active"
                        to="/transactions"
                        className="list-group-item"
                      >
                        Transactions
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        activeClassName="is-active"
                        to="/subscribe"
                        className="list-group-item"
                      >
                        Subscription
                      </NavLink>
                    </li>
                  </>
                )}
                {auth.user.user_type !== "Technician" && !auth.user.multistore && (
                  <>
                    <li>
                      <NavLink
                        activeClassName="is-active"
                        to="/sub-users"
                        className="list-group-item"
                      >
                        Users
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        activeClassName="is-active"
                        to="/notifications"
                        className="list-group-item"
                      >
                        Notification Settings
                      </NavLink>
                    </li>

                    <li>
                      <a className="nav-link" href="#" onClick={onLogoutClick}>
                        Logout ({user.email})
                      </a>
                    </li>
                  </>
                )}
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(Navbar);
